module.exports = __webpack_public_path__ + "assets/aafb2d92b46d4e9f66514d74cd0afdee.png";